/**
 * Auto-submits a snippets/facets.liquid form on change when it opts in via
 * data-facets-auto-submit (the desktop instance). The mobile instance omits
 * that attribute and relies on its own Apply button instead - same markup,
 * two behaviors, delegated from one document-level listener so it works
 * regardless of how many facets forms a page renders.
 */
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-price-range-pill]')) {
    const group = event.target.closest('[data-price-range]');
    const minInput = group?.querySelector('[data-price-min]');
    const maxInput = group?.querySelector('[data-price-max]');

    group?.querySelectorAll('[data-price-range-pill]').forEach((input) => {
      if (input !== event.target) input.checked = false;
    });

    if (event.target.checked) {
      if (minInput) minInput.value = event.target.dataset.priceRangeMin || '';
      if (maxInput) maxInput.value = event.target.dataset.priceRangeMax || '';
    } else {
      if (minInput) minInput.value = '';
      if (maxInput) maxInput.value = '';
    }
  }

  const form = event.target.closest('form[data-facets-auto-submit]');
  if (form) form.requestSubmit();
});
